import React from "react";

// @mui component
import type { TableBodyProps } from "@mui/material/TableBody";
import XTableBody from "@mui/material/TableBody";

const TableBody: React.FC<TableBodyProps> = (props) => {
  return <XTableBody {...props}>{props.children}</XTableBody>
};

export default TableBody;
